/* eslint-disable @typescript-eslint/no-explicit-any */
class ChannelService {
  constructor() {
    this.loadScript();
  }

  loadScript() {
    const w = window as any;
    if (w.ChannelIO) {
      return (window.console.error || window.console.log)(
        "ChannelIO script included twice."
      );
    }
    const ch = function () {
      // eslint-disable-next-line prefer-rest-params
      ch.c(arguments);
    };
    ch.q = [] as any[];
    ch.c = function (args: any) {
      ch.q.push(args);
    };
    w.ChannelIO = ch;
    function l() {
      if (w.ChannelIOInitialized) {
        return;
      }
      w.ChannelIOInitialized = true;
      const s = document.createElement("script");
      s.type = "text/javascript";
      s.async = true;
      s.src = "https://cdn.channel.io/plugin/ch-plugin-web.js";
      s.charset = "UTF-8";
      const x = document.getElementsByTagName("script")[0];
      x.parentNode!.insertBefore(s, x);
    }
    if (document.readyState === "complete") {
      l();
    } else if (w.attachEvent) {
      w.attachEvent("onload", l);
    } else {
      window.addEventListener("DOMContentLoaded", l, false);
      window.addEventListener("load", l, false);
    }
  }

  boot(settings: any) {
    const w = window as any;
    w.ChannelIO("boot", settings);
  }

  shutdown() {
    const w = window as any;
    w.ChannelIO("shutdown");
  }
}

export default new ChannelService();
